import { render, staticRenderFns } from "./EModalRegistrarAcompanhamento.vue?vue&type=template&id=6b605628"
import script from "./EModalRegistrarAcompanhamento.vue?vue&type=script&lang=js"
export * from "./EModalRegistrarAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports